import React from "react";
import { FormControl, RadioGroup, Stack, Radio, Text } from "@chakra-ui/react";
import { InputProps } from "../../types/component";

type SelectInputProps = Omit<InputProps, "size"> & {
  value_options: Record<string, string>;
};

export default function SelectInput({
  label,
  current_value,
  update_action,
  value_options,
}: SelectInputProps) {
  return (
    <FormControl>
      {label && (
        <Text textStyle="s2" mb="4px">
          {label}
        </Text>
      )}
      <RadioGroup
        value={current_value}
        onChange={(selected) => update_action(selected)}
      >
        <Stack direction="column" spacing={0.5} width="fit-content">
          {Object.entries(value_options).map(([key, value], index) => (
            <Radio
              key={index}
              value={value}
              size="sm"
              border="1px"
              borderColor="#0C727E"
              _focus={{
                boxShadow: "none",
              }}
              _checked={{
                bg: "brand.primaryDark",
              }}
            >
              <Text textStyle="b2" color="text.dark">
                {key}
              </Text>
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
    </FormControl>
  );
}
